  export const logout = () => {
    sessionStorage.clear();
    localStorage.clear();
  
    //const tenantId = process.env.TENANT_ID; 
    const postLogoutRedirectUri = process.env.REACT_APP_HOST_NAME; 
    const logoutUrl = postLogoutRedirectUri;
  
    window.location.href = logoutUrl;
  };